import axios from 'axios';
import tokenUtils from './tokenUtils';

const API_URL =
  process.env.NODE_ENV === 'test'
    ? process.env.REACT_APP_TESTS_API_URL
    : process.env.REACT_APP_API_URL;

const getHeaders = () => ({
  headers: {
    Authorization: !!tokenUtils.getToken() && `Bearer ${tokenUtils.getToken()}`,
    'content-type': 'application/json',
  },
});

class Request {
  delete = (url) => axios.delete(`${API_URL}${url}`, getHeaders());
  deleteMultiple = (url, body) => {
    const headers = {
      Authorization:
        !!tokenUtils.getToken() && `Bearer ${tokenUtils.getToken()}`,
      'content-type': 'application/json',
    };
    return axios.delete(`${API_URL}${url}`, { headers, data: body });
  };
  get = (url) => axios.get(`${API_URL}${url}`, getHeaders());
  put = (url, body) => axios.put(`${API_URL}${url}`, body, getHeaders());
  post = (url, body) => axios.post(`${API_URL}${url}`, body, getHeaders());
  patch = (url, body) => axios.patch(`${API_URL}${url}`, body, getHeaders());
}

const requests = new Request();

export const auth = {
  login: (username, password) =>
    requests.post('/auth/login', { username: username, password: password }),
  loginBank: (username, password) =>
    requests.post('/auth/bank/login', {
      username: username,
      password: password,
    }),
  register: (payload) => requests.post('/auth/register', payload),
  activate: (payload) => requests.post('/auth/activate', payload),
  resetPassword: (username) =>
    requests.post('/auth/reset', { username: username }),
  changePassword: (password, token) =>
    requests.post('/auth/change-password', {
      newPassword: password,
      token: token,
    }),
};

export const token = {
  refresh: (data) => requests.post('/api/token/refresh', data),
};

export const admin = {
  createUser: (data) => requests.post('/admin/create-user', data),
  getUsers: () => requests.get(`/admin/user`),
  editUser: (id, data) => requests.put(`/admin/user/${id}`, data),
  deleteUser: (id) => requests.delete(`/admin/user/${id}`),
};

export const password = {
  apiChange: (data) => requests.post('/api/password', data),
  bankChange: (data) => requests.post('/auth/bank/change-password', data),
  bankReset: (data) => requests.post('/auth/bank/reset', data),
  change: (data) => requests.post('/auth/change-password', data),
  reset: (data) => requests.post('/auth/reset', data),
  setPassword: (data) => requests.post('/api/password/set', data),
};

export const user = {
  getNotes: (loanID) => requests.get(`/api/notes/${loanID}`),
  addNote: (id, data) => requests.post(`/api/note/${id}`, data),
  getOneNote: (id) => requests.get(`/api/note/${id}`),
  editNote: (id, data) => requests.put(`/api/note/${id}`, data),
  deleteNote: (id) => requests.delete(`/api/note/${id}`),
  deleteUser: () => requests.delete(`/api/user`),
};

export const loan = {
  getAll: () => requests.get('/api/loan'),
  getIncome: (id) => requests.get(`/api/loan/income/${id}`),
  getLiabilities: (loanID) => requests.get(`/api/loan/liabilities/${loanID}`),
  getData: (id) => requests.get(`/api/loan/detailed/${id}`),
  getAdditionalIncomes: (id) => requests.get(`/api/loan/${id}/incomes`),
};

export const directPayment = {
  fields: (id, farmId) =>
    requests.get(`/api/farm/${farmId}/direct-payment/fields/${id}`),
  year: (id, year) =>
    requests.get(`/api/farm/${id}/direct-payment/year/${year}`),
};

export const incomeParameters = {
  animals: () => requests.get(`/api/animal-parameters`),
  crop: () => requests.get(`/api/crop-parameters`),
  editAnimalParameter: (id, data) =>
    requests.patch(`/bank/animal-parameters/${id}`, data),
  editCropParameter: (id, data) =>
    requests.patch(`/bank/crop-parameters/${id}`, data),
  editCropGroupParameters: (data) =>
    requests.patch(`/bank/crop-parameters/group`, data),
  editAnimalGroupParameters: (data) =>
    requests.patch(`/bank/animal-parameters/group`, data),
};

export const simulation = {
  all: () => requests.get('/bank/simulation'),
  simple: () => requests.get('/bank/simulation/simple'),
  create: (data) => requests.post('/bank/simulation', data),
  result: (id) => requests.get(`/bank/simulation/${id}/simulate`),
  delete: (id) => requests.delete(`/bank/simulation/${id}`),
};
